import React, { Component } from "react";
import { connect } from "react-redux";
import EditEvent from "./components/edit-event";
import EditEventnew from "./components/edit-event-new";

class General extends Component {
  constructor(props) {
    super(props);
    this.editEventRef = React.createRef();
    this.submit = this.submit.bind(this);
  }

  submit() {
    this.editEventRef.current.wrappedInstance.submitSettings();
  }

  render() {
    let { deviceSize } = this.props;

    return (
      <div
        className="main-content-body"
        style={{ height: deviceSize.height - 145 }}
      >
        <div className="row">
          <div className="col-sm-6 general-container container-padding">
            <EditEvent
              history={this.props.history}
              submitSettingsHandler={this.props.submitSettingsHandler}
              ref={this.editEventRef}
            />
          </div>

          <div className="col-sm-6 general-container container-padding">
            <EditEventnew
              history={this.props.history}
              submitSettingsHandler={this.props.submitSettingsHandler}
              ref={this.editEventRef}
            />
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {}, null, {
  forwardRef: true,
})(General);
